import { useEffect, useRef } from "react";

const pendingReloadPaths = new Set<string>();
const RELOAD_EVENT = "template:bottom-nav-reload";

export function requestBottomNavReload(path: string): void {
  pendingReloadPaths.add(path);
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(RELOAD_EVENT, { detail: { path } }));
  }
}

export function consumeBottomNavReload(path: string): boolean {
  const had = pendingReloadPaths.has(path);
  pendingReloadPaths.delete(path);
  return had;
}

export function useBottomNavReload(path: string, onReload: () => void): void {
  const onReloadRef = useRef(onReload);
  onReloadRef.current = onReload;

  useEffect(() => {
    if (consumeBottomNavReload(path)) {
      onReloadRef.current();
    }

    const handler = (event: Event) => {
      const detail = (event as CustomEvent<{ path: string }>).detail;
      if (detail?.path === path) {
        consumeBottomNavReload(path);
        onReloadRef.current();
      }
    };
    window.addEventListener(RELOAD_EVENT, handler);
    return () => window.removeEventListener(RELOAD_EVENT, handler);
  }, [path]);
}
